import axios from 'axios';
import { AxiosPromise } from 'axios';
import { IGetAuth, IAuthReq, IGetServerDate, IGetJwtToken, IJwtTokenReq, IGetResult, IGenerateReq, IGetAuthFind, IAuthFind } from '../models/auth.model';

const uri = '/home/auth/SU';

export const login = (data: IAuthReq): AxiosPromise<IGetAuth> => {
  return axios.post(`${uri}/login`, data);
}

export const logout = (): AxiosPromise<IGetAuth> => {
  return axios.get(`${uri}/logout`);
}

export const check = (): AxiosPromise<IGetAuth> => {
  return axios.get(`${uri}/check`);
}

export const switchAuth = (memberCode: string): AxiosPromise<IGetAuth> => {
  return axios.get(`/mgmt/employees/login/${memberCode}`);
}

export const getServerDate = (): AxiosPromise<IGetServerDate> => {
  return axios.get('/home/auth/serverDate');
}

export const getJwtToken = (data: IJwtTokenReq): AxiosPromise<IGetJwtToken> => {
  return axios.post('/home/auth/jwt-token', data);
}

export const verifyLoginFind = (data: IAuthReq): AxiosPromise<IGetAuthFind> => {
  return axios.post(`${uri}/login/verify/find`, data);
}
